"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Side = _interopRequireDefault(require("../Nav/Side"));

var _Top = _interopRequireDefault(require("../Nav/Top"));

var _withTheme = require("../../wrappers/with-theme");

var _index = require("../index");

var _HeaderComponent = _interopRequireDefault(require("../Header/HeaderComponent"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FixedLayout = function FixedLayout(_ref) {
  var _ref$headerBar = _ref.headerBar,
      headerBar = _ref$headerBar === void 0 ? true : _ref$headerBar,
      navPosition = _ref.navPosition,
      _ref$navBar = _ref.navBar,
      navBar = _ref$navBar === void 0 ? "side" : _ref$navBar,
      _ref$userMenu = _ref.userMenu,
      userMenu = _ref$userMenu === void 0 ? "header" : _ref$userMenu,
      _ref$menus = _ref.menus,
      menus = _ref$menus === void 0 ? [] : _ref$menus,
      menuItems = _ref.menuItems,
      props = _objectWithoutProperties(_ref, ["headerBar", "navPosition", "navBar", "userMenu", "menus", "menuItems"]);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1],
      toggle = _react["default"].useCallback(function (e) {
    setOpen(function (open) {
      return !open;
    });
  }, []);

  var theme = (0, _withTheme.useTheme)();

  var _useComponents = (0, _index.useComponents)(),
      TopUserMenu = _useComponents.TopUserMenu,
      SideUserMenu = _useComponents.SideUserMenu;

  navBar = navPosition === undefined ? navBar : navPosition;
  menuItems = menuItems === undefined ? menus : menuItems;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n      ".concat(theme.bg, " ").concat(theme.text, "\n      min-h-screen w-full flex flex-col\n    ")
  }, navBar !== 'top' ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "fixed left-0 top-0 right-0 z-10"
  }, /*#__PURE__*/_react["default"].createElement(_Top["default"], _extends({}, props, {
    menuItems: menuItems,
    open: open,
    toggle: toggle,
    rightMenu: !headerBar || userMenu === "nav" ? /*#__PURE__*/_react["default"].createElement(TopUserMenu, null) : ''
  }))), !headerBar ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n            fixed left-0 top-0 right-0 z-10\n            ".concat(navBar === 'side' ? "md:ml-".concat(theme.sidebarW, " ") : '', "\n          ")
  }, /*#__PURE__*/_react["default"].createElement(_HeaderComponent["default"], {
    userMenu: userMenu === "header",
    title: (0, _lodash["default"])(headerBar, "title", null)
  }, (0, _lodash["default"])(props, ["headerBar", "children"], []).map(function (child, i) {
    return typeof child === "function" ? /*#__PURE__*/_react["default"].createElement(child, {
      key: i
    }) : typeof child === "string" ? child : /*#__PURE__*/_react["default"].cloneElement(child, {
      key: i
    });
  }))), navBar !== 'side' ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "fixed"
  }, /*#__PURE__*/_react["default"].createElement(_Side["default"], _extends({}, props, {
    menuItems: menuItems,
    open: open,
    toggle: toggle,
    bottomMenu: !headerBar || userMenu === "nav" ? /*#__PURE__*/_react["default"].createElement(SideUserMenu, null) : ''
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n        flex-1 flex\n        ".concat(headerBar || navBar === "top" ? "pt-".concat(theme.topNavHeight || _constants.DEFAULT_TOP_NAV_HEIGHT) : '', "\n        ").concat(navBar === 'side' ? "md:pl-".concat(theme.sidebarW) : '', "\n      "),
    style: {
      alignItems: "stretch",
      justifyContent: "stretch"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full h-full"
  }, props.children))));
};

var _default = FixedLayout;
exports["default"] = _default;